export default __webpack_public_path__ + "static/media/fv_finances.82bf3280.svg";